/* istanbul ignore file */

import { ErrorPage, PageLoading, useRequestInit, withErrorBoundary } from "adviesbox-shared";
import React, { ReactElement } from "react";
import useAbortableFetch from "use-abortable-fetch";
import { saveData } from "../shared/utils/save-data";
import { mapDlTargetToLastenoverzichtUiField, mapLastenoverzichtDlToUi, mapLastenoverzichtUiToDl } from "./infra";
import Lastenoverzicht from "./lastenoverzicht";

const LastenoverzichtAjax = (): ReactElement => {
  // TODO: replace useRequestInit/useAbortableFetch with useAdviesboxData

  const { params, requestInit, settings, user } = useRequestInit();

  const url = `${settings.instellingenFormsOrigin}/Lastenoverzicht`;
  const { loading, error, data } = useAbortableFetch<any>(url, requestInit);

  if (!user) {
    return <ErrorPage error={new Error("Missing AuthContext")} />;
  }

  if (error) {
    return <ErrorPage error={error} data={data} />;
  }

  if (typeof data === "string") {
    return <ErrorPage error={new Error("Invalid data")} data={data} />;
  }

  if (loading || !data) {
    return <PageLoading />;
  }

  const mappedProps = mapLastenoverzichtDlToUi(data);
  if (!mappedProps) {
    return <PageLoading />;
  }

  return (
    <Lastenoverzicht
      saveData={saveData(
        user,
        params.vestiging ?? "",
        url,
        settings.OcpApimSubscriptionKey,
        mapLastenoverzichtUiToDl,
        mapDlTargetToLastenoverzichtUiField
      )}
      {...mappedProps}
    />
  );
};

LastenoverzichtAjax.displayName = "lastenoverzichtAjax";

export default withErrorBoundary(LastenoverzichtAjax);
